<template>
  <v-container fluid class="d-flex align-center justify-center fill-height pa-0 h-screen"
    style="background-color: #f6f4f1;">
    <v-card elevation="18" width="450" class="pa-8 rounded-xl" style="background-color: #ffffff;">
      <div class="text-center mb-8">
        <h2 class="text-h5 font-weight-bold mb-1 text-primary">
          Criar Nova Conta
        </h2>
        <p class="text-body-2 text-neutrals_muted">
          Preencha seus dados para começar a usar a plataforma.
        </p>
      </div>

      <v-form @submit.prevent="handleRegister" ref="formRef">
        <v-text-field v-model="form.name" label="Nome Completo" prepend-inner-icon="mdi-account-outline"
          variant="outlined" required class="mb-4" color="primary" :error-messages="validationErrors.name" />

          <v-text-field v-model="form.phone" label="Whatsapp" v-maska="'(##) #####-####'" prepend-inner-icon="mdi-whatsapp"
          variant="outlined" required class="mb-4" color="primary" :error-messages="validationErrors.phone" />

        <v-text-field v-model="form.email" label="E-mail" type="email" prepend-inner-icon="mdi-email-outline"
          variant="outlined" required class="mb-4" color="primary" :error-messages="validationErrors.email" />

        <v-text-field v-model="form.password" :type="passwordVisible ? 'text' : 'password'" label="Senha"
          prepend-inner-icon="mdi-lock-outline" variant="outlined" required
          :append-inner-icon="passwordVisible ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="passwordVisible = !passwordVisible" class="mb-6" color="primary"
          :error-messages="validationErrors.password" />

        <v-btn type="submit" block size="large" class="text-white" :loading="isSubmitting" :disabled="isSubmitting"
          color="primary" style="font-weight:600;">
          Cadastrar
        </v-btn>
      </v-form>

      <div class="d-flex justify-center mt-4">
        <a @click.prevent="goToLogin" href="#" class="text-body-2 text-decoration-none text-primary">
          Já tem conta? Faça login
        </a>
      </div>
      
      </v-card>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
// Ajuste os imports abaixo para onde seus arquivos estão localizados
import api from "@/services/api"; 
import { useToastStore } from '@/store/toast'; 
import { useStore } from "vuex"

const store = useStore();

const form = ref({
  name: "",
  phone: "",
  email: "",
  password: "",
});
const passwordVisible = ref(false);
const isSubmitting = ref(false);
const validationErrors = ref({});

const router = useRouter();
const toastStore = useToastStore();

function validateForm() {
  const errors = {};
  const data = form.value;

  if (!data.name.trim()) {
    errors.name = "O nome é obrigatório.";
  }
  if (!data.phone.trim()) {
    errors.phone = "O Whatsapp é obrigatório.";
  }
  if (!data.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
    errors.email = "E-mail inválido ou obrigatório.";
  }
  if (!data.password) {
    errors.password = "A senha é obrigatória.";
  } else if (data.password.length < 6) {
    errors.password = "A senha deve ter no mínimo 6 caracteres.";
  }

  validationErrors.value = errors;
  return Object.keys(errors).length === 0;
}

async function handleRegister() {
  if (!validateForm()) {
    toastStore.showToast({
      message: 'Por favor, corrija os campos indicados.',
      color: 'warning',
    });
    return;
  }

  isSubmitting.value = true;
  try {
    form.value.role = 'client';
    const response = await api.post("/register", {
      name: form.value.name,
      phone: form.value.phone,
      email: form.value.email,
      password: form.value.password,
    });

    toastStore.showToast({
      message: 'Cadastro realizado com sucesso! Verifique seu e-mail para confirmar o seu cadastro',
      color: 'success',
    });

    setTimeout(() => {
      router.push({ name: 'login' }); 
    }, 2500);

  } catch (error) {
    console.error("Erro ao cadastrar:", error);
    toastStore.showToast({
      message: error?.response?.data?.error || 'Erro ao cadastrar usuário.',
      color: 'error',
    });
  } finally {
    isSubmitting.value = false;
  }
}

const goToLogin = () => {
  router.push({ name: 'login' });
}
</script>

<style scoped>
/* Estilos para garantir cores da paleta */
.text-primary {
  color: #152a34 !important;
}
.text-neutrals_muted {
  color: #6b7280 !important;
}
</style>